import { DecisionMakerService } from './decision-maker.service';
import { PERMISSIONS, PERMISSIONS_DECISION_MAKER_SERVICE, ROLES } from './injection-tokens';

const permissionsDecisionMakerServiceFactory = (permissions: Record<string, string[]>, roles: string[]) => {
  const service = new DecisionMakerService();

  service.setPermissions(permissions).setRoles(roles);

  return service;
};

export const permissionsDecisionMakerServiceProvider = {
  provide: PERMISSIONS_DECISION_MAKER_SERVICE,
  useFactory: permissionsDecisionMakerServiceFactory,
  deps: [PERMISSIONS, ROLES],
};
